import IndustryLandingTemplate, { IndustryPageData } from '@/components/industry/IndustryLandingTemplate';

const salonWellnessData: IndustryPageData = {
  slug: 'salon-wellness',
  name: 'Salon & Wellness',
  heroHeadline: 'Transform Client Satisfaction into Stunning Google Reviews',
  heroSubheadline: 'Help your salon, spa, or wellness center attract more clients with AI-generated review suggestions that showcase your expertise.',
  painPoint: '89% of people look up salon reviews before booking their first appointment',
  trustProblem: 'In the beauty industry, one bad review about a haircut can keep clients away for months.',
  challenges: [
    {
      title: 'Visual Results, No Written Proof',
      description: 'Clients love their new look but leave without writing about it. Your transformations aren\'t documented online.',
    },
    {
      title: 'Service-Specific Visibility',
      description: 'When someone searches "best hair color salon" or "bridal makeup artist", you don\'t appear in results.',
    },
    {
      title: 'High Competition Locality',
      description: 'Multiple salons in your area mean you need more reviews to stand out in local searches.',
    },
    {
      title: 'Price vs. Value Perception',
      description: 'Without reviews mentioning quality and results, potential clients only compare prices.',
    },
  ],
  useCases: [
    {
      category: 'Hair Services',
      description: 'Reviews for haircuts, coloring, styling, and treatments.',
      keywords: ['best haircut', 'hair color expert', 'hair spa'],
    },
    {
      category: 'Beauty & Makeup',
      description: 'Reviews for makeup, facials, and beauty treatments.',
      keywords: ['bridal makeup', 'party makeup', 'facial treatment'],
    },
    {
      category: 'Spa & Wellness',
      description: 'Reviews for massages, body treatments, and wellness services.',
      keywords: ['body massage', 'relaxation spa', 'ayurvedic treatment'],
    },
  ],
  caseStudy: {
    businessType: 'Unisex Salon & Spa',
    city: 'Mumbai',
    challenges: [
      'Only 35 reviews despite 8 years of operation in Bandra',
      'Not appearing in "hair salon Bandra" or "spa near me" searches',
      'Losing clients to newer salons with aggressive online presence',
    ],
    solution: 'Implemented Review Plum with categories for Hair, Skin, and Spa services. Created service-specific review templates mentioning specific treatments and stylist names.',
    results: [
      { metric: 'Google Reviews', value: '35 → 175' },
      { metric: 'Google Rating', value: '4.0 → 4.6' },
      { metric: 'New Appointments', value: '+75%' },
      { metric: 'Bridal Inquiries', value: '+90%' },
    ],
  },
  sampleReviews: [
    {
      category: 'Hair Services',
      reviews: [
        {
          text: 'Best hair coloring experience ever! Got balayage done at this salon in Bandra and the results exceeded my expectations. The stylist understood exactly what I wanted and the color turned out perfect. The hair spa treatment afterwards made my hair so soft. Top hair salon in Mumbai!',
          keywords: ['hair coloring', 'salon in Bandra', 'hair salon in Mumbai'],
        },
        {
          text: 'Finally found a salon that knows how to handle curly hair! The haircut was perfect and they used products suited for my hair type. The ambience is lovely and staff is very professional. Best haircut experience in Western Mumbai. Will definitely recommend to friends.',
          keywords: ['curly hair', 'haircut', 'Western Mumbai'],
        },
      ],
    },
    {
      category: 'Makeup',
      reviews: [
        {
          text: 'Got my bridal makeup done here and looked absolutely stunning! The makeup artist understood my skin tone and preferences perfectly. The look lasted throughout the wedding day and night. Best bridal makeup artist in Mumbai for South Indian brides.',
          keywords: ['bridal makeup Mumbai', 'makeup artist', 'South Indian bride'],
        },
        {
          text: 'Amazing party makeup experience! The artist used high-quality products and the makeup was flawless in photos. Very reasonable rates for the quality. Highly recommend for any special occasion makeup in Bandra.',
          keywords: ['party makeup', 'occasion makeup Bandra', 'makeup service'],
        },
      ],
    },
    {
      category: 'Spa',
      reviews: [
        {
          text: 'The full body massage was incredibly relaxing! The spa ambience is serene and the therapist was very professional. Used aromatic oils that left my skin feeling amazing. Best spa experience in Western Mumbai.',
          keywords: ['full body massage', 'spa Western Mumbai', 'aromatic massage'],
        },
        {
          text: 'Tried their Ayurvedic treatment package and it was worth every rupee. The Shirodhara therapy relieved all my stress. Clean facilities and trained therapists. Top wellness center in Juhu for authentic treatments.',
          keywords: ['Ayurvedic treatment', 'Shirodhara', 'wellness center Juhu'],
        },
      ],
    },
  ],
  cityKeywords: [
    'salon in Mumbai',
    'spa Delhi',
    'beauty parlour Bengaluru',
    'hair salon Chennai',
    'wellness center Pune',
    'makeup artist Hyderabad',
  ],
  nearMeKeywords: [
    'salon near me',
    'spa near me',
    'beauty parlour nearby',
    'hair salon close by',
    'best salon near me',
    'massage center nearby',
  ],
  ctaText: 'Get More Client Reviews',
};

export default function SalonWellnessPage() {
  return <IndustryLandingTemplate data={salonWellnessData} />;
}
